import { useId, type SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

export function DarsiBookMark({ className, ...props }: IconProps) {
  const gradientId = useId();
  const leftGradientId = `${gradientId}-left`;
  const rightGradientId = `${gradientId}-right`;

  return (
    <svg viewBox="0 0 44 44" aria-hidden="true" className={className} {...props}>
      <defs>
        <linearGradient id={leftGradientId} x1="7" x2="21" y1="8" y2="36" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00B941" />
          <stop offset="1" stopColor="#089B35" />
        </linearGradient>
        <linearGradient id={rightGradientId} x1="23" x2="37" y1="8" y2="36" gradientUnits="userSpaceOnUse">
          <stop stopColor="#7FE09B" />
          <stop offset="1" stopColor="#18B84D" />
        </linearGradient>
      </defs>
      <path
        d="M6 10.7c0-1.2 1.1-2.1 2.3-1.8l12 3.2c1 .3 1.7 1.2 1.7 2.3v22c0 1.2-1.1 2.1-2.3 1.8l-12-3.2A2.35 2.35 0 0 1 6 32.7v-22Z"
        fill={`url(#${leftGradientId})`}
      />
      <path
        d="M38 10.7c0-1.2-1.1-2.1-2.3-1.8l-12 3.2c-1 .3-1.7 1.2-1.7 2.3v22c0 1.2 1.1 2.1 2.3 1.8l12-3.2c1-.3 1.7-1.2 1.7-2.3v-22Z"
        fill={`url(#${rightGradientId})`}
      />
      <path d="M22 14.4v22" stroke="#EFFFF3" strokeLinecap="round" strokeWidth="2.4" />
      <path d="M11 13.2v16.9" stroke="#DDFCE7" strokeLinecap="round" strokeOpacity=".65" strokeWidth="1.7" />
      <path d="M33 13.2v16.9" stroke="#F1FFF5" strokeLinecap="round" strokeOpacity=".8" strokeWidth="1.7" />
    </svg>
  );
}

export function MoroccoFlagIcon({ className, ...props }: IconProps) {

  return (
    <svg width="800px" height="800px" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className={className} {...props} preserveAspectRatio="xMidYMid meet"><path fill="#C1272D" d="M32 5H4a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z"></path><path fill="#006233" d="M15.047 22.165l1.128-3.471l-2.953-2.145h3.649L18 13.074l1.129 3.474h3.649l-2.953 2.145l1.128 3.471L18 20.019l-2.953 2.146zm3.583-2.603l.916.665l-.35-1.077l-.566.412zm-1.826-.412l-.35 1.077l.916-.665l-.566-.412zm.241-.74l.955.694l.955-.694l-.365-1.122h-1.182l-.363 1.122zM15.5 17.288l.915.665l.216-.665H15.5zm3.869 0l.216.665l.915-.665h-1.131zm-1.019-.74L18 15.47l-.35 1.079h.7z"></path></svg>
  )
}

export function WordIcon({ className, ...props }: IconProps) {
  const gradientId = useId();

  return (


    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={800}
      height={800}
      viewBox="0 0 32 32"
      className={className}
      {...props}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1={4.494}
          x2={13.832}
          y1={-1712.086}
          y2={-1695.914}
          gradientTransform="translate(0 1720)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#2368c4" />
          <stop offset={0.5} stopColor="#1a5dbe" />
          <stop offset={1} stopColor="#1146ac" />
        </linearGradient>
      </defs>
      <title>{"file_type_word"}</title>
      <path
        d="M28.806 3H9.705a1.192 1.192 0 0 0-1.193 1.191V9.5l11.069 3.25L30 9.5V4.191A1.192 1.192 0 0 0 28.806 3Z"
        style={{
          fill: "#41a5ee",
        }}
      />
      <path
        d="M30 9.5H8.512V16l11.069 1.95L30 16Z"
        style={{
          fill: "#2b7cd3",
        }}
      />
      <path
        d="M8.512 16v6.5l10.418 1.3L30 22.5V16Z"
        style={{
          fill: "#185abd",
        }}
      />
      <path
        d="M9.705 29h19.1A1.192 1.192 0 0 0 30 27.809V22.5H8.512v5.309A1.192 1.192 0 0 0 9.705 29Z"
        style={{
          fill: "#103f91",
        }}
      />
      <path
        d="M16.434 8.2H8.512v16.25h7.922a1.2 1.2 0 0 0 1.194-1.191V9.391A1.2 1.2 0 0 0 16.434 8.2Z"
        style={{
          opacity: 0.10000000149011612,
          isolation: "isolate",
        }}
      />
      <path
        d="M15.783 8.85H8.512V25.1h7.271a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191Z"
        style={{
          opacity: 0.20000000298023224,
          isolation: "isolate",
        }}
      />
      <path
        d="M15.783 8.85H8.512V23.8h7.271a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191Z"
        style={{
          opacity: 0.20000000298023224,
          isolation: "isolate",
        }}
      />
      <path
        d="M15.132 8.85h-6.62V23.8h6.62a1.2 1.2 0 0 0 1.194-1.191V10.041a1.2 1.2 0 0 0-1.194-1.191Z"
        style={{
          opacity: 0.20000000298023224,
          isolation: "isolate",
        }}
      />
      <path
        d="M3.194 8.85h11.938a1.193 1.193 0 0 1 1.194 1.191v11.918a1.193 1.193 0 0 1-1.194 1.191H3.194A1.192 1.192 0 0 1 2 21.959V10.041A1.192 1.192 0 0 1 3.194 8.85Z"
        style={{
          fill: `url(#${gradientId})`,
        }}
      />
      <path
        d="M6.9 17.988c.023.184.039.344.046.481h.028c.01-.13.032-.287.065-.47s.062-.338.089-.465l1.255-5.407h1.624l1.3 5.326a7.761 7.761 0 0 1 .162 1h.022a7.6 7.6 0 0 1 .135-.975l1.039-5.358h1.477l-1.824 7.748h-1.727l-1.237-5.126q-.054-.222-.122-.578t-.084-.52h-.021q-.021.189-.084.561c-.042.249-.075.432-.1.552L7.78 19.871H6.024L4.19 12.127h1.5l1.131 5.418a4.469 4.469 0 0 1 .079.443Z"
        style={{
          fill: "#fff",
        }}
      />
    </svg>

  )
  return (
    <svg viewBox="0 0 36 36" aria-hidden="true" className={className} {...props}>
      <rect x="11" y="5" width="20" height="24" rx="2.8" fill="#41A5EE" />
      <rect x="14" y="8" width="19" height="23" rx="2.8" fill="#185ABD" opacity=".88" />
      <rect x="4" y="10" width="19" height="20" rx="2.8" fill="#0F6CBD" />
      <text
        x="13.5"
        y="24"
        fill="white"
        fontFamily="var(--font-geist-sans), system-ui, sans-serif"
        fontSize="13"
        fontWeight="800"
        textAnchor="middle"
      >
        W
      </text>
    </svg>
  );
}

export function CurvedArrow({ className, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 72 42" fill="none" aria-hidden="true" className={className} {...props}>
      <path
        d="M4 32c18-22 42-22 60-4"
        stroke="#08A62F"
        strokeLinecap="round"
        strokeWidth="3"
      />
      <path d="m57 19 9 10-13 1" stroke="#08A62F" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
    </svg>
  );
}
